// extracted by mini-css-extract-plugin
export default {"wrapper":"DataTable_wrapper__5n3Lu","tableContainer":"DataTable_tableContainer__48Etl","table":"DataTable_table__VOmOD","paginationWrapper":"DataTable_paginationWrapper__YHEpN"};